import { StyleSheet } from 'react-native';
import { colors } from '../../constants';

export default StyleSheet.create({
  pillBody: {
    display: 'flex',
    flexDirection: 'row',
    borderRadius: 24,
    paddingVertical: 4,
    paddingHorizontal: 8,
    alignItems: 'center',
    backgroundColor: colors.greys.veryLight,
  },
  pillLabel: {
    color: colors.greys.dark,
    fontWeight: '600',
    marginRight: 8,
    paddingVertical: 4,
  },
  toggle: {
    marginLeft: 8,
  },
});
